import { LegacyCard, RadioButton, Stack } from "@shopify/polaris";
import { FC, useCallback } from "react";
import { FieldRenderProps } from "react-final-form";
import { useDispatch } from "react-redux";
import {
  SELECT_PRODUCTS_BASED_ON_ALL,
  SELECT_PRODUCTS_BASED_ON_SPECIFIC,
  SELECT_PRODUCTS_BASED_ON_TAGS,
} from "../../../../../../../../constants/selectProductsBasedOn.js";
import { TAGS_SELECTION_LOGIC_EXCLUDE } from "../../../../../../../../constants/tagsSelectionLogic.js";
import { updateStockSelectedProducts } from "../../../../../../../store/features/action.js";

interface SelectVariantCardProps extends FieldRenderProps<any> { }

const SelectVariantCard: React.FC<SelectVariantCardProps> = ({ input, setIsProductUsed, setFilterValues, values, form }) => {
  const dispatch = useDispatch();

  const clearSelectedProducts = useCallback(
    (newValue) => {
      const clearedData = {
        selectProductsBasedOn: newValue,
        tagsSelectionLogic: TAGS_SELECTION_LOGIC_EXCLUDE,
        selectedTags: [],
        selectedSpecificItems: [],
        exceptionList: []
      };
      dispatch(updateStockSelectedProducts(clearedData));
      setFilterValues({});
    },
    [dispatch, input]
  );

  const handleChange = useCallback(
    (_checked, newValue) => {
      input.onChange(newValue);
      setIsProductUsed(false)
      form.reset({
        ...values,
        hasValidationErrors: false,
        submitFailed: false,
      });
      clearSelectedProducts(newValue);
    },
    [input, form, values, clearSelectedProducts]
  );

  return (
    <LegacyCard sectioned>
      <Stack vertical spacing={"extraTight"}>
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_SPECIFIC}
          label="Specific products & collections"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_SPECIFIC}
          name="productBy"
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_ALL}
          label="All products & collections"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_ALL}
          onChange={handleChange}
        />
        <RadioButton
          id={SELECT_PRODUCTS_BASED_ON_TAGS}
          label="Select or exclude products based on tags"
          name="productBy"
          checked={input.value === SELECT_PRODUCTS_BASED_ON_TAGS}
          onChange={handleChange}
        />
      </Stack>
    </LegacyCard>
  );
};

export default SelectVariantCard;